import React, { useState } from "react";

import OpenInvoices from "./Invoices";
const OpenInvoicesMainPage = ({}) => {
  return (
    <div className="pt-[83px] md:px-6 px-4">
      {" "}
      <OpenInvoices />
    </div>
  );
};

export default OpenInvoicesMainPage;
